const startPage = "/start";
const SendIdentityCodePage = "/sendIdentityCode";
const PersonalInformationPage = "/personalInformation";
const AddressPage = "/address";
const PhoneNumberPage = "/phoneNumber";
const OTPPage = "/otp";
const HasRegisteredPage = "/hasRegistered";
export {
  startPage,
  SendIdentityCodePage,
  PersonalInformationPage,
  AddressPage,
  PhoneNumberPage,
  OTPPage,
  HasRegisteredPage,
};
